var _circle, _g, _circle2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_600_12220",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 47,
    height: 46
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.6168,
    cy: 22.7164,
    r: 22.65,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_600_12220)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_600_12220",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 47,
    height: 46
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.6168,
    cy: 22.7164,
    r: 22.65,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_600_12220)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.966797,
    y: 39.7041,
    width: 39.6375,
    height: 45.3,
    transform: "rotate(-90 0.966797 39.7041)",
    fill: "#F5F7F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.6172,
    y: 11.3916,
    width: 5.6625,
    height: 22.65,
    transform: "rotate(-90 23.6172 11.3916)",
    fill: "#DD2033"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.6172,
    y: 22.7163,
    width: 5.6625,
    height: 22.65,
    transform: "rotate(-90 23.6172 22.7163)",
    fill: "#DD2033"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.966797,
    y: 34.0415,
    width: 5.6625,
    height: 45.3,
    transform: "rotate(-90 0.966797 34.0415)",
    fill: "#DD2033"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.966797,
    y: 45.3662,
    width: 5.6625,
    height: 45.3,
    transform: "rotate(-90 0.966797 45.3662)",
    fill: "#DD2033"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.966797,
    y: 22.7163,
    width: 22.65,
    height: 22.65,
    transform: "rotate(-90 0.966797 22.7163)",
    fill: "#004692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8352 13.9081L17.71 16.4533L15.0602 16.7919L17.0146 18.7037L16.5021 21.4581L18.8352 19.8852L21.1683 21.4581L20.6558 18.7037L22.6102 16.7919L19.9604 16.4533L18.8352 13.9081Z",
    fill: "#F5F7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8352 -1.19189L17.71 1.35328L15.0602 1.69193L17.0146 3.60367L16.5021 6.35811L18.8352 4.78519L21.1683 6.35811L20.6558 3.60367L22.6102 1.69193L19.9604 1.35328L18.8352 -1.19189Z",
    fill: "#F5F7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8019 6.35811L12.6767 8.90328L10.0269 9.24193L11.9813 11.1537L11.4688 13.9081L13.8019 12.3352L16.135 13.9081L15.6225 11.1537L17.5769 9.24193L14.9271 8.90328L13.8019 6.35811Z",
    fill: "#F5F7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.13941 13.9081L7.01418 16.4533L4.36439 16.7919L6.31881 18.7037L5.80627 21.4581L8.13939 19.8852L10.4725 21.4581L9.95997 18.7037L11.9144 16.7919L9.2646 16.4533L8.13941 13.9081Z",
    fill: "#F5F7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.13941 -1.19189L7.01418 1.35328L4.36439 1.69193L6.31881 3.60367L5.80627 6.35811L8.13939 4.78519L10.4725 6.35811L9.95997 3.60367L11.9144 1.69193L9.2646 1.35328L8.13941 -1.19189Z",
    fill: "#F5F7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10607 6.35811L1.98084 8.90328L-0.668945 9.24193L1.28547 11.1537L0.772935 13.9081L3.10605 12.3352L5.43917 13.9081L4.92664 11.1537L6.88105 9.24193L4.23127 8.90328L3.10607 6.35811Z",
    fill: "#F5F7F8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsd);
export default __webpack_public_path__ + "static/media/USD.a04c4d3ae9b61ec13e960f0916ecb069.svg";
export { ForwardRef as ReactComponent };